import {Route, Routes} from 'react-router-dom'
import PrivateLayout from 'layouts/PrivateLayout'
import PublicLayout from 'layouts/PublicLayout'
import AdminDashboardPage from 'pages/admin/DashboardPage'
import Login from 'pages/Login'
import Page404 from 'pages/Page404'
import Signup from 'pages/Signup'
import PublicSignupLayout from 'layouts/PublicSignupLayout'
import Forgot from 'pages/Forgot'
import TrucksPage from 'pages/admin/TrucksPage'
import CustomersPage from 'pages/admin/Customers'
import OrdersPage from 'pages/admin/Orders'
import LocationsPage from 'pages/admin/LocationsPage'
import SettingsPage from 'pages/admin/SettingsPage'
import BreakoutLayout from 'layouts/BreakoutLayout'
import BlackoutsPage from 'pages/admin/BlackoutsPage'
import CreateTruckPage from 'pages/admin/trucks/CreateTruckPage'
import LocationsCreatePage from 'pages/admin/LocationsCreatePage'
import LocationsEditPage from 'pages/admin/LocationsEditPage'
import EditTruckPage from 'pages/admin/trucks/EditTruckPage'
import CreateCustomerPage from 'pages/admin/customers/CreateCustomerPage'
import EditCustomerPage from 'pages/admin/customers/EditCustomerPage'
import OrderPage from 'pages/admin/OrderPage'
import BookingDetailsPage from 'pages/admin/BookingDetailsPage'
import SettingsCurrentUserPage from 'pages/admin/SettingsCurrentUserPage'
import SettingsEditUserPage from 'pages/admin/SettingsEditUserPage'
import EditBookingPage from 'pages/admin/EditBookingPage'
import CSVExportPage from './pages/admin/CsvExportPage'
import OrderCreatePage from './pages/admin/OrderCreatePage'

function App() {
    return (
        <Routes>
            <Route path="/forgot-password" element={<Forgot/>}/>

            <Route element={<PublicLayout/>}>
                <Route path="/" element={<Login/>}/>
                <Route path="*" element={<Page404/>}/>
            </Route>

            <Route element={<PublicSignupLayout/>}>
                <Route path="/signup" element={<Signup/>}/>
            </Route>

            <Route element={<PrivateLayout/>}>
                {/* Admin routes */}
                <Route path="/admin/dashboard" element={<AdminDashboardPage/>}/>
                <Route
                    path="/admin/user/settings"
                    element={<SettingsCurrentUserPage/>}
                />
                <Route
                    path="/admin/settings/user/:userEmail"
                    element={<SettingsEditUserPage/>}
                />
                <Route path="/admin/locations" element={<LocationsPage/>}/>
                <Route
                    path="/admin/locations/create"
                    element={<LocationsCreatePage/>}
                />
                <Route
                    path="/admin/locations/:locationId"
                    element={<LocationsEditPage/>}
                />
                <Route
                    path="/admin/locations/:locationId/:date"
                    element={<LocationsEditPage/>}
                />
                <Route path="/admin/trucks" element={<TrucksPage/>}/>
                <Route path="/admin/trucks/create" element={<CreateTruckPage/>}/>
                <Route path="/admin/trucks/:classId" element={<EditTruckPage/>}/>
                <Route path="/admin/customers" element={<CustomersPage/>}/>
                <Route
                    path="/admin/customers/create"
                    element={<CreateCustomerPage/>}
                />
                <Route
                    path="/admin/customers/:customerId"
                    element={<EditCustomerPage/>}
                />
                <Route path="/admin/orders" element={<OrdersPage/>}/>
                <Route path="/admin/orders/:orderId" element={<OrderPage/>}/>
                <Route
                    path="/admin/orders/:orderId/booking-details/:bookingId"
                    element={<BookingDetailsPage/>}
                />
                {/*<Route path="/admin/reports" element={<CSVExportPage />} />*/}
                <Route path="/admin/settings" element={<SettingsPage/>}/>
                <Route path="/admin/export" element={<CSVExportPage/>}/>
                <Route path="/admin/order/create" element={<OrderCreatePage/>}/>
            </Route>
            <Route element={<BreakoutLayout/>}>
                <Route path="/admin/locations/blackouts" element={<BlackoutsPage/>}/>
            </Route>

            <Route
                element={
                    <BreakoutLayout
                        title="Reschedule Booking Slot"
                        description="Select a new time slot"
                    />
                }
            >
                <Route
                    path="/admin/orders/:orderId/booking-details/:bookingId/edit"
                    element={<EditBookingPage/>}
                />
            </Route>
        </Routes>
    )
}

export default App
